import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import isEqual from 'lodash.isequal';
import {
  Scrollbars,
} from 'rhinostyle';
import FilterPage from '../components/FilterPage';
import { useQueryParams } from '../hooks';
import { calculatePastDateRange } from '../helpers/AppointmentHelpers';
import ReportFilters from '../components/ReportFilters';
import { validateQueryStringValue } from '../helpers/PrescriptionHelpers';
import { fetchFormTemplates } from '../reducers/formReducer';
import { fetchTags } from '../reducers/tagReducer';
import { fetchOrganizationRolesView } from '../reducers/roleReducer';
import { fetchGroups } from '../reducers/groupReducer';

const ReportsAnalyticsView = () => {
  const dispatch = useDispatch();
  const defaultDate = calculatePastDateRange(6);

  const initialValue = {
    reportType: '',
    // form report
    formType: '',
    selectedFormTemplate: '',
    selectedFormTemplateId: '',
    selectedFormTemplateLabel: 'Select Form Template',
    startDate: defaultDate.startDate,
    endDate: defaultDate.endDate,
    // user report
    userType: '',
    selectedContactTypeIds: [],
    selectContactTypes: [],
    tagIds: [],
    tagNames: [],
    status: 'all',
    customRoles: [],
    customRoleNames: [],
    systemRoles: [],
    systemRoleNames: [],
    groups: [],
    groupNames: [],
  };

  const [filters, onSetFilters] = useQueryParams({ initialValue, validateQueryStringValue });

  function handleClearAll() {
    onSetFilters(initialValue);
  }

  useEffect(() => {
    if (filters.reportType === 'form' && filters.formType !== '') {
      dispatch(fetchFormTemplates('all', true, filters.formType));
    }
    if (filters.reportType === 'user') {
      dispatch(fetchTags());
      dispatch(fetchOrganizationRolesView());
      dispatch(fetchGroups());
    }
  }, [filters]);

  function handleUpdateFilters(changeObj) {
    onSetFilters({
      ...changeObj,
    });
  }

  function getActiveFilterValues(values) {
    const {
      startDate: sd,
      endDate: ed,
      ...activeValues
    } = values;
    return activeValues;
  }

  const showClearAll = !isEqual(getActiveFilterValues(filters), getActiveFilterValues(initialValue));

  const renderFilters = () => (
    <ReportFilters handleChange={handleUpdateFilters} filters={filters} />
  );

  return (
    <div className="app-page">
      <div className="app-panels">
        <div className="list-panel__wrapper">
          <div className="list-panel">
            <div className="list-panel__body" data-feature-tag="routingCategoryList">
              <Scrollbars className="library-scroll__container">
                <div className="list-panel">
                  <div className="app-page__header">
                    <div className="app-page__header__title">
                      Reports
                    </div>
                  </div>
                  <FilterPage
                    hasPanels
                    hasFilters
                    showClearAll={showClearAll}
                    clearAllFilters={handleClearAll}
                    type="reports"
                    renderFilters={renderFilters}
                    showPageHeader
                  />
                </div>
              </Scrollbars>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsAnalyticsView;
